import { ActionItem, ActionItemStyle, EllipsisMultiActionItem, OpenDirection } from '@stylehaven/components';

export function MoreActionsButton(actions: ActionItem[], disabledInfoMsg: string = ''): ActionItem {
    return EllipsisMultiActionItem(
        actions,
        false,
        ActionItemStyle.PureIconButton,
        OpenDirection.LeftOverlap,
        disabledInfoMsg
    );
}
